import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ellf-form-field-wrapper',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      label {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      button.toolTip {
        background: none;
        border: 0;
      }
      .feedback {
        font-size: 12px;
        //   margin-top: 3px;
        //   font-size: 11px;
        //   color: rgba(178, 177, 172);
        // }
        // .feedback mark {
        //   background-color: rgba(248, 237, 202, 0.8);
      }
    `,
  ],
  template: `
    <ng-template #tipContent>{{ tooltip }}</ng-template>
    <label [title]="label" class="text-secondary"
      >{{ label }}
      @if (tooltip.length > 0) {
        <button
          type="button"
          class="toolTip cursor-pointer text-primary feather icon-help-circle"
          [ngbTooltip]="tipContent"
          placement="top"
          [title]="''"
          ></button
          >
        }</label>
        <ng-content></ng-content>
        @for (err of errors; track err) {
          <div
            class="feedback"
            [class.invalid-feedback]="shouldShowError"
            >
            <!-- <mark> -->{{ err
          }}<!-- </mark> -->
        </div>
      }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormFieldWrapperComponent {
  @Input()
  label = '';

  @Input()
  tooltip = '';

  @Input()
  errors: string[] = [];

  @Input()
  shouldShowError = false;
}
